import { FC, ReactNode } from 'react'
import styled from 'styled-components'

export const ContentsWrapper = styled.div`
	flex-grow: 1;
	background-color: ${(props) => props.theme.new.colors.sol_gray_0};
`
export const ContentsContainer = styled.div`
	max-width: 600px;
	margin: 0 auto;
	padding: 40px 0;

	@media (max-width: 1200px) {
	}
	@media (max-width: 430px) {
		width: 100%;
		margin: 40px 0;
		padding: 0 16px;
	}
`

export const ContentsStyledTitle = styled.h2`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 24px;
	font-size: 24px;
	font-weight: 600;
	line-height: 32px;
	color: ${(props) => props.theme.new.colors.sol_gray_900};
`
export const Subtitle = styled.p`
	font-size: 16px;
	font-weight: 400;
	line-height: 1.5;
	letter-spacing: -0.16px;
	color: ${(props) => props.theme.new.colors.sol_gray_500};
`

export const ContentsTitle: FC<{ primary: ReactNode; secondary?: ReactNode }> = ({
	primary,
	secondary,
}) => {
	return (
		<>
			<ContentsStyledTitle>
				{primary}
				{!!secondary && <Subtitle>{secondary}</Subtitle>}
			</ContentsStyledTitle>
		</>
	)
}

export const NoticeContainer = styled.div`
	margin: 40px 0;
	display: flex;
	gap: 8px;
	flex-direction: column;
	p {
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 22px; /* 157.143% */
		letter-spacing: -0.14px;

		color: ${(props) => props.theme.new.colors.sol_gray_500};
		font-weight: 600;
	}
`
// page/packages/index 스타일 동일한 부분...충돌 방지로 가져와 사용중, 나중에 정리해야
export const NoticeList = styled.ul`
	font-size: 14px;

	li {
		font-weight: 400;
		color: ${(props) => props.theme.new.colors.sol_gray_500};

		line-height: 22px;
		list-style: initial;
		margin-inline-start: 24px;
	}
	@media (max-width: 768px) {
		li {
			font-size: 14px;
		}
	}
`
